import { type ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'
import { Button } from './Button'

interface ErrorStateProps {
  title?: string
  message?: string
  action?: ReactNode
  onRetry?: () => void
}

export function ErrorState({
  title = '오류가 발생했습니다',
  message = '잠시 후 다시 시도해 주세요.',
  action,
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex min-h-60 flex-col items-center justify-center gap-4 px-6 py-10 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-danger-soft text-danger">
        <AlertTriangle aria-hidden className="size-6" />
      </div>
      <div>
        <h1 className="text-preset-heading text-text">{title}</h1>
        <p className="mt-1 max-w-sm text-preset-caption text-text-muted">{message}</p>
      </div>
      {action ?? (onRetry ? <Button onClick={onRetry}>다시 시도</Button> : null)}
    </div>
  )
}
